import { render, staticRenderFns } from "./HubForm.vue?vue&type=template&id=2dd3919e"
import script from "./HubForm.vue?vue&type=script&lang=js"
export * from "./HubForm.vue?vue&type=script&lang=js"
import style0 from "./HubForm.vue?vue&type=style&index=0&id=2dd3919e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports